export const getMonthlyLeaderboardMonths = () => {
    const monthlyStartYear = 2025;
    const monthlyStartMonth = 1;

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1; // JavaScript months are 0-indexed

    const months = [];

    let year = currentYear;
    let month = currentMonth;

    while (year > monthlyStartYear || (year === monthlyStartYear && month >= monthlyStartMonth)) {
        // Format as YYMM (e.g., 2602 for Feb 2026)
        const monthYear = `${String(year).slice(-2)}${month.toString().padStart(2, '0')}`;
        months.push(Number(monthYear));

        // Decrement the month, and handle year change if necessary
        month -= 1;
        if (month < 1) {
            month = 12;
            year -= 1;
        }
    }

    return months;
};

export const readableMonthYear = monthYear => {
    const monthYearString = monthYear.toString();
    const year = '20' + monthYearString.slice(0, 2);
    const month = monthYearString.slice(2, 4);
    const monthNum = Number(month);
    const monthName = numberToMonth(monthNum);
    return `${monthName} ${year}`;
};

export const numberToMonth = monthNumber => {
    // Use year 2000, day 1 to avoid timezone and day-of-month rollover issues
    const date = new Date(2000, monthNumber - 1, 1);
    return date.toLocaleString('en-US', { month: 'short' });
};

// Format an ISO date string as m/d/yy. Returns '' for missing/invalid input.
export const formatShortDate = iso => {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return `${d.getMonth() + 1}/${d.getDate()}/${String(d.getFullYear()).slice(-2)}`;
};

// Same as formatShortDate but falls back to "today" when iso is missing — used by freshly-awarded
// badges in the post-game modal, where earnedAt is implicitly "now".
export const formatShortDateOrToday = iso => formatShortDate(iso) || formatShortDate(new Date().toISOString());
